<template>
  <div class="mention-input">
    <input
        type="text"
        class="form-control"
        v-model="inputValue"
        @input="onInput"
        @keydown.enter.prevent="selectCurrentSuggestion"
        placeholder="Tippe @ für Vorschläge"
    />

    <ul v-if="showSuggestions" class="suggestions-dropdown">
      <li
          v-for="(suggestion, index) in filteredSuggestions"
          :key="suggestion"
          :class="{ 'is-active': index === activeSuggestionIndex }"
          @click="selectSuggestion(suggestion)"
      >
        {{ suggestion }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SuggestionInput",
  props: {
    value: {
      type: String,
      required: true,
    },
    suggestions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      inputValue: this.value,
      filteredSuggestions: [],
      showSuggestions: false,
      activeSuggestionIndex: 0,
    };
  },
  watch: {
    value(newValue) {
      this.inputValue = newValue;
    },
  },
  methods: {
    selectCurrentSuggestion() {
      if (this.filteredSuggestions.length > 0) {
        const suggestion = this.filteredSuggestions[this.activeSuggestionIndex];
        this.selectSuggestion(suggestion);
      }
    },
    onInput() {
      this.$emit("input", this.inputValue);
      const lastAtIndex = this.inputValue.lastIndexOf("@");

      if (lastAtIndex >= 0) {
        const query = this.inputValue.substring(lastAtIndex + 1).toLowerCase();
        this.filteredSuggestions = this.suggestions.filter((suggestion) =>
            suggestion.toLowerCase().includes(query)
        );
        this.showSuggestions = this.filteredSuggestions.length > 0;
      } else {
        this.showSuggestions = false;
      }
    },
    selectSuggestion(suggestion) {
      const cursorPosition = this.inputValue.lastIndexOf("@");
      const beforeAt = this.inputValue.substring(0, cursorPosition);

      this.inputValue = `${beforeAt}${suggestion}`;
      this.showSuggestions = false;
      this.$emit("input", this.inputValue);
    },
  },
};
</script>

<style scoped>
.mention-input {
  position: relative;
}

.suggestions-dropdown {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 150px;
  overflow-y: auto;
  width: 100%;
  z-index: 10;
}

.suggestions-dropdown li {
  padding: 10px;
  cursor: pointer;
}

.suggestions-dropdown li:hover,
.suggestions-dropdown li.is-active {
  background: #f0f0f0;
}
</style>
